/**
 * drawerSchema.js — arg/type shapes only, NO component imports.
 *
 * Split from `drawerRegistry.js` to break a circular import:
 *   drawerRegistry → SiteDetailLayer → SiteDetails → layerNav → drawerParser → drawerRegistry
 * The parser only needs the schema (arg names + coercion types) to validate
 * and normalise URL segments, not the component references. Component
 * resolution stays in `drawerRegistry.js` and is consumed only by
 * `DrawerStack.vue`.
 */

export const drawerSchema = Object.freeze({
  site: {
    args: ['id', 'tab', 'subtab', 'subsubtab'],
    types: { id: 'int', tab: 'string', subtab: 'string', subsubtab: 'string' }
  },
  // L1 view from /utility: a site's utility-bill LIST (legacy
  // /utility/:utilityId → SiteUtilTable). Chevron from /utility row should
  // open this, not jump straight to a single bill.
  siteUtil: {
    args: ['id', 'tab', 'subtab'],
    types: { id: 'int', tab: 'string', subtab: 'string' }
  },
  // L2 single bill detail (legacy /utility/:utilityId/bill/:billId →
  // SiteUtilBillDetail). Reached from inside a `siteUtil` or `site` (Power
  // tab) drawer, never directly from a list.
  bill: {
    args: ['id', 'tab', 'subtab'],
    types: { id: 'int', tab: 'string', subtab: 'string' }
  },
  // L1 request detail (XOL-209 PR 3). Opened from /requests/<typeSlug>.
  // tab/subtab reserved for future sub-tab routing — not wired in this PR.
  request: {
    args: ['id', 'tab', 'subtab'],
    types: { id: 'int', tab: 'string', subtab: 'string' }
  }
})

export function isKnownDrawer (name) {
  return Object.prototype.hasOwnProperty.call(drawerSchema, name)
}
